module.exports = __webpack_public_path__ + "media/emergency-alarm.a32ba18c.mp3";